<ion-content force-overscroll="false" [ngClass]="{'transparentBody': showTransparentBody}">
  <app-header
    [iconName]="'menu'"
    [title]="null"
    [menuToggleRight]="true"
    [showErrorMessageNetwork]="true"
    [hidden]="showTransparentBody">
  </app-header>
  @if (!isOnline()) {
    <div class="error-network">
      <span class="error-network-container">
        <i class="icon-warning"></i>
        <span>{{"NoAccessInternet" | translate}}</span>
      </span>
    </div>
  }

  @if (overlay) {
    <div class="overlay"></div>
  }

  <div [ngClass]="{'none' : showTransparentBody}">

    <div class="go-content pl20 pr20">

      <div class="mt20 code-section">

        <div style="border-bottom: 1px solid #ccc">
          @if (showPinCodeTitle()) {
            <span>{{'PinCode' | translate}}</span>
          }
          @if (showPinCodeRequiredText()) {
            <span class="color-danger">{{'PinCodeRequired' | translate}}</span>
          }
          @if (showResetPinCodeButton()) {
            <button class="pretty-button__small fl-right" (click)="toggleEnterPinCode()">
              {{'Reset' | translate}}
            </button>
          }
          @if (showCreatePinCodeButton()) {
            <button class="pretty-button__small fl-right" (click)="toggleEnterPinCode()">
              {{'Create' | translate}}
            </button>
          }
        </div>
        <div class="pt10 pb10">
          @if (showPinCodeDisabled()) {
            <span class="color-danger">{{'PinCodeDisabled' | translate}}</span>
          }
          @if (pinCodeConflict) {
            <span class="color-danger">{{'PinCodeConflict' | translate}}<i class="icon-close fl-right pseudo-link" (click)="pinCodeConflict = false"></i></span>
          }
          @if (showPinCodeDots()) {
            <div class="password-dot__container">
              <div class="password-dot"></div>
              <div class="password-dot"></div>
              <div class="password-dot"></div>
              <div class="password-dot"></div>
            </div>
          }
          @if (showDeletePinCodeIcon()) {
            <i class="icon-delete fl-right mr5 pseudo-link" (click)="deletePinCode()"></i>
          }
          @if (gettingPinCode) {
            <ion-spinner name="lines"></ion-spinner>
          }
          @if (showNoPinCodeDash()) {
            <span>-</span>
          }

          @if (enterPinCode) {
            <div>
              <form (ngSubmit)="setPinCode()">
                <div>
                  <input
                  class="pretty-input"
                  name="setPinCodeInput"
                  type="text"
                  maxlength="4"
                  placeholder="{{'EnterPinCode' | translate}}"
                  [ngClass]="{'input-warning' : invalidPinCode}"
                  (ngModelChange)="checkPinCode($event)"
                  [(ngModel)]="newPinCode">
                  <i class="icon-close fl-right pseudo-link" (click)="toggleEnterPinCode()"></i>
                </div>
                <div class="pt10">
                  <button type="submit" class="btn btn-primary" [disabled]="incompletePinCode || invalidPinCode">
                    {{'Save' | translate  }}
                  </button>
                </div>
              </form>
            </div>
          }
        </div>
      </div>

      <div class="mt20 code-section">
        <div style="border-bottom: 1px solid #ccc">
          <span>{{'IdCode' | translate}}</span>
          @if (showResetIdCodeButton()) {
            <button class="pretty-button__small fl-right size80" (click)="resetIdCode()">
              {{'Reset' | translate}}
            </button>
          }
          @if (showCreateIdCodeButton()) {
            <button class="pretty-button__small fl-right" (click)="setIdCode()">
              {{'Create' | translate}}
            </button>
          }
        </div>

        <div class="pt10 pb10">
          @if (idCodeResource && !gettingIdCode) {
            <span>
              {{idCodeResource.idCode}}
            </span>
          }
          @if (gettingIdCode) {
            <ion-spinner name="lines"></ion-spinner>
          }
          @if (showNoIdCodeDash() && !gettingIdCode) {
            <span>-</span>
          }
          @if (showDeleteIdCodeIcon() && !gettingIdCode) {
            <i class="icon-delete fl-right mr5 pseudo-link" (click)="deleteIdCode()"></i>
          }
        </div>
      </div>

      <div class="mt20">
        <div style="border-bottom: 1px solid #ccc">
          {{'Cards' | translate}}
          @if (showRegisterCardDialogButton()) {
            <button class="pretty-button__small fl-right" (click)="registerCardDialog()">
              {{'RegisterCard' | translate}}
            </button>
          }
        </div>
        <form (ngSubmit)="registerCard()">
          @if (showRegisterCardForm()) {
            <div class="pt10 pb10 register-card" style="border-bottom: 1px solid #ccc">
              <input
              class="pretty-input"
              type="text"
              name="registerCardInput"
              maxlength="6"
              placeholder="{{'EnterCode' | translate}}"
              [ngClass]="{'input-warning' : invalidCardCode}"
              (ngModelChange)="checkCardCode($event)"
              [(ngModel)]="cardCode"
              autofocus>
              <i class="icon-close fl-right pseudo-link" (click)="registerCardDialog()"></i>
              <div class="pt20">
                <button type="submit" class="btn btn-primary" [disabled]="incompleteCardCode || invalidCardCode">
                  {{'Save' | translate}}
                </button>
              </div>

              @if (isCordova) {
                <button class="btn btn-primary scan-qr-button" type="button" (click)="openQRScanner()">
                  {{'Scan' | translate}}
                  <i class="icon-qr-code-2"></i>
                </button>
              }
            </div>
          }
        </form>
        @for (card of cards; track $index) {
          <div class="pt5 pb5">
            {{card.created | amDateFormat :"YYYY-MM-DD"}}
            @if (showDeleteCardIcon()) {
              <i class="icon-delete fl-right mr5 pseudo-link" (click)="deleteCard(card)"></i>
            }
          </div>
        }
      </div>

      @if (showDelegatedConsents()) {
        <div class="mt40">
          <div style="border-bottom: 1px solid #ccc">
            {{'Consents' | translate}}
          </div>
          <!-- $index, not a composite key off the row. consentUrl is the only field carrying
               anything identifying — kind, providerId and directory sit in its query string — but
               it is typed string | null and the Authorize button below gates on it, so it cannot
               key every row. That leaves kind and directoryName, and
               directoryName is a display name, which nothing guarantees is unique. Duplicate keys
               would be NG0955 in dev and positional DOM reuse in prod; the list is short and
               rebuilt wholesale, so index tracking costs nothing. -->
          @for (consent of delegatedConsents(); track $index) {
            <div class="pt10 pb10 consent-row">
              <div>{{consentKindLabel(consent)}}</div>
              <div class="size80">
                {{consent.directoryName}}
              </div>
              <div class="size80">
                @if (!consent.consentRequired) {
                  <span>{{'Authorized' | translate}}</span>
                } @else {
                  <span class="color-danger">{{'NotAuthorized' | translate}}</span>
                }
              </div>
              @if (consent.consentRequired && consent.consentUrl) {
                <button class="pretty-button__small fl-right" (click)="authorizeDelegatedConsent(consent)">
                  {{'Authorize' | translate}}
                </button>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (showTransparentBody) {
    <div class="qr-overlay-container">
      <button class="stop-qr-scanner" [ngClass]="{'ios': isIOS}" (click)="cancelQRScanner()">
        <i class="icon-close"></i>
      </button>
      <div class="qr-focus" [ngClass]="{'qr-warning': invalidQRCode}">
        <div class="qr-msg-container">
          @if (!invalidQRCode) {
            <div class="size70">{{'ScanQR' | translate}}</div>
          } @else {
            <div class="size70">{{'InvalidQRCode' | translate}}</div>
          }
          <div class="size120"><i class="icon-qr-code-2"></i></div>
        </div>
      </div>
    </div>
  }
</ion-content>
